import React from "react";
import { ArrowUpProfitIcon, ArrowDownLossIcon } from "assets/icons";
import {
  AccountCell,
  // PositionCell,
  // PriceCell,
  ValueCell,
  ReturnCell,
  AccountLogo,
  ReturnPill,
} from "./YourActiveHoldings.styles";

export const columns = [
  {
    dataField: "account",
    text: "Connected Brokers",
    props: {
      cell: ({ getValue, row }) => {
        return (
          <AccountCell>
            <AccountLogo src={row.original.imageUrl} alt={getValue()} />
            <span>{getValue()}</span>
          </AccountCell>
        );
      },
    },
  },
  // {
  //   dataField: "positions",
  //   text: "Positions",
  //   props: {
  //     cell: ({ getValue }) => <PositionCell>{getValue()}</PositionCell>,
  //   },
  // },
  // {
  //   dataField: "averagePrice",
  //   text: "Average price",
  //   props: {
  //     cell: ({ getValue }) => {
  //       return <PriceCell>{getValue() || "--"}</PriceCell>;
  //     },
  //   },
  // },
  {
    dataField: "totalValue",
    text: "Invested Amount",
    props: {
      cell: ({ getValue, row }) => {
        return (
          <ValueCell>
            {getValue()} <span>{row.original.positions}</span>
          </ValueCell>
        );
      },
    },
  },
  {
    dataField: "allTimeReturn",
    text: "Returns",
    props: {
      cell: ({ getValue }) => {
        const amount = getValue().amount;
        const percent = getValue().percent;
        const percentNumber = Number(percent?.split("%")[0]);
        const isPositive = percentNumber > 0;
        const isZero = percentNumber === 0;
        const isNegative = percentNumber < 0;

        return (
          <ReturnCell
            $color={isPositive ? "#027a48" : isNegative ? "#d92d20" : "#667085"}
          >
            {amount}
            {!isZero && (
              <ReturnPill isPositive={isPositive}>
                {isPositive ? (
                  <ArrowUpProfitIcon width={14} height={14} />
                ) : (
                  <ArrowDownLossIcon width={14} height={14} />
                )}
                {percent}
              </ReturnPill>
            )}
          </ReturnCell>
        );
      },
    },
  },
  {
    dataField: "investedSince",
    text: "Invested Since",
    props: {
      cell: ({ getValue }) => <ValueCell>{getValue() || "--"}</ValueCell>,
    },
  },
];
